/*
 * @Author: zjw
 * @Date: 2021-05-25 14:55:57
 * @LastEditTime: 2022-11-16 16:25:20
 * @FilePath: \web-app\src\network\system\user.js
 * @Environment: Vue + Element
 * @Description: 
 */
import {
    request,
} from '../request.js'

// 用户列表
export function userList(data) {
    return request({
        url: '/web/back/sys/user/list',
        method: 'post',
        data

    })
}

// 添加
export function addUser(data) {
    return request({
        url: '/web/back/sys/user/insert',
        method: 'post',
        data
    })
}

// 修改
export function editUser(data) {
    return request({
        url: '/web/back/sys/user/update',
        method: 'post',
        data
    })
}

// 删除
export function delUser(data) {
    return request({
        url: '/web/back/sys/user/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelUser(data) {
    return request({
        url: '/web/back/sys/user/batch/delete',
        method: 'delete',
        data
    })
}

//用户id查询角色数组
export function getUserRole(data) {
    return request({
        url: '/web/back/sys/user/getRole' + "?userId=" + data,
        method: 'get',
        data
    })
}

//更改用户角色
export function updateUserRole(data) {
    return request({
        url: '/web/back/sys/user/updateRole',
        method: 'post',
        data
    })
}

//文章分类分配权限
export function articleSortPermissions(data) {
    return request({
        url: '/web/back/sys/navigationUser/save',
        method: 'post',
        data
    })
}
//权限分配用户查询
export function userListAuth(data) {  
    return request({
        url: '/web/back//sys/user/listUser',
        method: 'post',
        data
    })
}